import { connect } from 'react-redux';
import { SuggestedProductListComponent } from 'swag-client-common/components/partials/suggested-product-list';
import { suggestedProductListSelector } from './connect/suggested-products.selector';
import { suggestedProductListDispatcher } from './connect/suggested-products.dispatcher';
export const SuggestedProducts = connect(suggestedProductListSelector, suggestedProductListDispatcher)(SuggestedProductListComponent);